"use client";
import React from "react";
import { Image } from "antd";
import Link from "next/link";
import { usePathname } from "next/navigation";
import Cookies from "js-cookie";

// Import images
import sidefixedimage from "../../assets/images/Red.gif";
import golderFixedImage from "../../assets/images/IS LIVE.gif";
// import PremierGif from "../../assets/images/Premier.gif";
import PremierGif from "../../assets/images/Premier (1).gif";
import PremierRedGif from "../../assets/images/Red Premier (1).gif";
import SpecialPremierGif from "../../assets/images/Premier-main.gif";
import RamadanGif from "../../assets/images/Ramadan.gif";
import SummerGif from "../../assets/images/summer_sale.gif";
import IslamicGif from "../../assets/images/islamic.gif";
import SummerIslamic from "../../assets/images/Summer-sale-islamic.gif";
import AzadiGif from "../../assets/images/azadi-gif.gif";
// import EpicGif from "../../assets/images/Epic.gif";
import EpicGif from "../../assets/images/new_year_giff.gif";


const FixedButton = () => {
  const pathname = usePathname();
  let themeType = Cookies.get("user_type");

  // Determine image source based on theme type
  const getImageSource = () => {
    if (themeType === "premier") {
      return SpecialPremierGif.src;
    } else if (themeType === "islamic") {
      return SummerGif.src;
    } else {
      return EpicGif.src;
    }
  };

  // Determine link destination based on theme type
  const getLinkDestination = () => {
    return themeType === "premier" ? "/premier" : "/new-year";
  };

  // Hide button on specific pages
  const shouldHideButton =
    pathname.includes("/new-year") ||
    pathname.includes("/cart") ||
    pathname.includes("/checkout") ||
    pathname.includes("/b2b-payments");

  if (shouldHideButton) {
    return null;
  }

  return (
    <Link
      className="fixed-button"
      href={getLinkDestination()}
      style={{
        position: "fixed",
        left: 0,
        bottom: "10%",
        width: "120px",
        height: "120px",
        // transform: "translateY(-50%)",
        padding: "10px 20px",
        backgroundColor: "transparent",
        cursor: "pointer",
      }}
    >
      <Image
        preview={false}
        src={getImageSource()}
        height="140px"
        width="auto"
      />
    </Link>
  );
};

export default FixedButton;
